import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import request from '@/utils/request';
import _ from 'lodash';
import { contractBaseUrl } from '@/common/settings';
// 合同列表 ,框架协议内网主列表
export function getContractList(params, pageParams) {
  let where = '';
  if (params.ZdocumentType === '' && params.zType === 'agreement') {
    where += '(substringof(\'10\', ZdocumentType) or substringof(\'20\', ZdocumentType)) and ';
    getParams(params);
  } else {
    getParams(params);
  }
  function getParams(params) {
    console.log('params', params);
    for (const key in params) {
      if (params[key] !== '' && params[key] !== 'agreement') {
        if (['ZconNameZ', 'Provider'].includes(key)) {
          where += `${key} eq '${params[key]}' and `;
        } else {
          let strSelect = '';
          if (_.isArray(params[key])) {
            if (params[key].length) {
              params[key].forEach(i => {
                strSelect += `substringof('${i}',${key}) or `;
              });
              where += '(' + strSelect.slice(0, strSelect.length - 3) + ') and ';
            }
          } else {
            where += `substringof('${params[key]}',${key}) and `;
          }
        }
      }
    }
  }
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/SearchAgreementSet`,
    method: 'get',
    params: {
      $format: 'json',
      $skip: pageParams.skip,
      $top: pageParams.top,
      $filter: where !== '' ? where.slice(0, where.length - 5) : ''
    }
  });
}
// 获取搜索条件字典 初始化获取阈值
export function getDomainListSet() {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/DomainListSet?$format=json`,
    method: 'get'
  });
}
// 获取合同详情
export function getContractDetails(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/ContHeadSet('${params.id}')`,
    method: 'get',
    params: {
      $expand: 'ContRangeSet,ContSignSet,ContPaySet,ContPartySet,ContMsgSet,ContItemSet,ContVerdictSet,ContTaxSet',
      $format: 'json'
    }
  });
}
export function getContractTabs(params) {
  let filter = '';
  for (const key in params) {
    filter += `${key} eq '${params[key]}' and `;
  }
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/ContTabSet`,
    method: 'get',
    params: {
      $filter: filter ? filter.slice(0, filter.length - 5) : '',
      $format: 'json'
    }
  });
}
export function postK2RretunInfoSet(params) {
  return request({
    url: `${contractBaseUrl}/ZFBC_K2_APPR_SRV/K2RretunInfoSet`,
    method: 'post',
    data: {
      ...params
    }
  });
}
// 删除合同 驳回合同 编辑合同
export function editContract(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/ContHeadSet`,
    method: 'post',
    data: {
      ...params
    }
  });
}
// 获取合同编辑表单动态渲染配置
export function getContractFormConfigs(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/ContConfigSet`,
    method: 'get',
    params: {
      $filter: `ZdocumentType eq '${params.ZdocumentType}' and ZconCategoryNo eq '${params.ZconCategoryNo}' and ZconClassNo1 eq '${params.ZconClassNo1}'`,
      $format: 'json'
    }
  });
}
// 补充合同编辑表单根据原因控制字段是否可修改（有返回的都是可修改，否则不可修改）
export function getContractReasonEditable(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/ContReasonSet`,
    method: 'get',
    params: {
      $filter: `ZconCategoryNo eq '${params.ZconCategoryNo}' and ZsReasonNo eq '${params.ZsReasonNo}'`
    }
  });
}
// 获取合同分类
export function getContractHeadSet() {
  return request({
    url: `${contractBaseUrl}ZFPC_CONT_CONFIG_SRV/ContractHeadSet`,
    method: 'get',
    params: {
      $expand: 'ContractAttchSet,ContractBchtSet,ContractPaySet,ContractMsgSet',
      $format: 'json'
    }
  });
}
// 获取区域项目
export function getRegionList(params, id) {
  let expand = 'children/children';
  if (id != '') {
    expand = 'children';
  }
  return request({
    url: `${contractBaseUrl}/ZFMD_DOMAINLIST_SRV/OrgTreeSet(level='${params}',id='${id}')`,
    method: 'get',
    params: {
      $expand: expand,
      $format: 'json'
    }
  });
}
/// sap/opu/odata/SAP/ZFMD_DOMAINLIST_SRV/OrgTreeSet(level='1',id='')?$expand=children/children&$format=json
// level=0集团-1总部-2区域-3项目-4分期；Id代表对象实际ID，label 代表对象描述
// 查询经办人
export function getHandlerList(param) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_CONFIG_SRV/SearchHelpSet?$filter=F4field eq 'Zuser' and ( substringof('ZJBR:${param}',Condition) )`,
    method: 'get',
    params: {
      $format: 'json'
    }
  });
}
/// sap/opu/odata/SAP/ZFMD_DOMAINLIST_SRV/OrgTreeSet(level='1',id='')?$expand=children/children&$format=json
// level=0集团-1总部-2区域-3项目-4分期；Id代表对象实际ID，label 代表对象描述
// 获取付款合计表格数据 - 付款信息页签
export function getPaymentInfo(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/TzHeadSet('${params}')?$format=json`,
    method: 'get'
  });
}
// 获取请款明细表格数据 - 付款信息页签
export function getRequestDetail(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/TzItemSet?$filter=ZdocumentNo eq '${params}' &$format=json`,
    method: 'get'
  });
}
// 获取付款明细表格数据 - 付款信息页签
export function getPaymentDetail(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/TzPaymentSet?$filter=ZdocumentNo eq '${params}' &$format=json`,
    method: 'get'
  });
}
// 获取发票表格数据 - 付款信息页签
export function getInvoiceDetail(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/TzInvSet?$filter=ZdocumentNo eq '${params}' &$format=json`,
    method: 'get'
  });
}
// 获取关联合同信息数据 - 关联合同
export function getRelevanceContract(params) {
  return request({
    url: `${contractBaseUrl}/ZFPC_CONT_RACT_SRV/TzRelaContSet?$filter=ZdocumentNo eq '${params}' &$format=json`,
    method: 'get'
  });
}
// 删除附件
export function removeAttFile(params) {
  return request({
    url: `/file/middleground/${params}`,
    method: 'delete'
  });
}
// 下载附件
export function downLoadAttFile(params) {
  return request({
    url: `/file/middleground/download/${params}`,
    method: 'get',
    responseType: 'blob'
  });
}